import React from 'react';
import ReactDOM from 'react-dom/client';
import '@fontsource-variable/vazirmatn/wght.css';
import '@fontsource-variable/inter/wght.css';
import './i18n';
import './index.css';
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<React.StrictMode><App /></React.StrictMode>);
